import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateGuideFeedbackByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  _set?: Types.InputMaybe<Types.Guide_Feedbacks_Set_Input>;
}>;


export type UpdateGuideFeedbackByIdMutation = { __typename?: 'mutation_root', update_guide_feedbacks_by_pk?: { __typename?: 'guide_feedbacks', id: any, helpful: boolean, notes?: string | null, created_by_user_id: string, created_at: any, guide_id: any } | null };


export const UpdateGuideFeedbackByIdDocument = gql`
    mutation updateGuideFeedbackById($id: uuid!, $_set: guide_feedbacks_set_input = {}) {
  update_guide_feedbacks_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
    helpful
    notes
    created_by_user_id
    created_at
    guide_id
  }
}
    `;
export type UpdateGuideFeedbackByIdMutationFn = Apollo.MutationFunction<UpdateGuideFeedbackByIdMutation, UpdateGuideFeedbackByIdMutationVariables>;

/**
 * __useUpdateGuideFeedbackByIdMutation__
 *
 * To run a mutation, you first call `useUpdateGuideFeedbackByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuideFeedbackByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuideFeedbackByIdMutation, { data, loading, error }] = useUpdateGuideFeedbackByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateGuideFeedbackByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGuideFeedbackByIdMutation, UpdateGuideFeedbackByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGuideFeedbackByIdMutation, UpdateGuideFeedbackByIdMutationVariables>(UpdateGuideFeedbackByIdDocument, options);
      }
export type UpdateGuideFeedbackByIdMutationHookResult = ReturnType<typeof useUpdateGuideFeedbackByIdMutation>;
export type UpdateGuideFeedbackByIdMutationResult = Apollo.MutationResult<UpdateGuideFeedbackByIdMutation>;
export type UpdateGuideFeedbackByIdMutationOptions = Apollo.BaseMutationOptions<UpdateGuideFeedbackByIdMutation, UpdateGuideFeedbackByIdMutationVariables>;